/*
 * ProfileConstants
 */

export const GET_AGENT_MEMBERS = 'ideal/Profile/GET_AGENT_MEMBERS';
export const AGENT_MEMBERS_LOADED = 'ideal/Profile/AGENT_MEMBERS_LOADED';
